import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import Video from 'components/Video';
import { useStyles } from './styles';
import Image from 'next/image';

const Props = {
  textTitle: PropTypes.string.isRequired,
  textDescription: PropTypes.node,
};

export default function CreatingScienceIllustrations({ textTitle, textDescription }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Container>
        <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
          <b>{textTitle}</b>
        </Typography>

        {textDescription && (
          <Box pt={3}>
            <Typography variant="h6" component="p" align="center">
              {textDescription}
            </Typography>
          </Box>
        )}

        <Box display="flex" justifyContent="center" alignItems="center">
          <Box className={classes.videoWrapper} py={6} pr={10}>
            <LazyLoad offset={50}>
              <Video
                className={classes.video}
                sources={[{ src: '/videos/institutions/illustrations.webm', type: 'video/webm' }]}
              />
            </LazyLoad>
          </Box>

          <Image
            src="/images/institutions/illustrations-80-fields.webp"
            alt="illustrations fields image"
            loading="lazy"
            width={517}
            height={250}
          />
        </Box>
      </Container>
    </LazyLoad>
  );
}

CreatingScienceIllustrations.propTypes = Props;
